export const namespace = 'canalplus.block.maverick.contact';
export { default as Component } from './components/Contact';
export { default as propsFormatter } from './propsFormatter';
